import "./style.scss";
export const storeCard = (storeNbr, name, addr, city, state, zip, Phone, contact, verificationState) => {
  const vTime =
    (verificationState != "null" && verificationState != ""
      ? new Date(verificationState) < new Date(new Date().setDate(new Date().getDate() - 90))
      : true) && !!verificationState;
  return `    
        <>
          <div class="store-card">
            <div class="store-card__align gap-2">
                <span class="store-card__data__store-pill store-card__text">${storeNbr}</span>
                <span class="store-card__text">${name}</span>
            </div>
            <div class="store-card__data__divider"></div>
        <div class="d-flex gap-4">
            <div class="d-flex">
                <div class="store-card vector-icon"></div>
            </div>
            <div class="d-flex">
            <div class="store-card__text store-card__align">${addr}, ${city}, ${state}, ${zip}</div>
            </div>
        </div>
      <div class="d-flex gap-4">
        <div class="d-flex">
          <div class="store-card user-icon"></div>
        </div>
        <div class="d-flex">
        <div class="store-card__text store-card__align">${contact === " " ? "N/A" : contact}</div>
        </div>
      </div>
      <div class="d-flex gap-4">
        <div class="d-flex">
          <div class="store-card phone-icon"></div>
        </div>
        <div class="d-flex">
        <div class="store-card__text store-card__last-element">${Phone}</div>
        </div>
      </div>
      <div class="store-card__data__divider"></div>
      <div class="d-flex justify-content-between">
        <div class="d-flex">
          <div class="store-card__text">Verification State</div>
        </div>
        <div class="d-flex gap-2">
          <div class="d-flex">
            <div class="store-card ${vTime ? "store-card crossPill-icon" : "store-card checkmark-icon"}"></div>
          </div>
          <div class="d-flex">
            <div class="store-card__text ms-auto">${vTime ? "not Verified" : "Verified"}</div>
          </div>
        </div>
      </div>
    
      </div>
    </>
    `;
};
